// extracted by mini-css-extract-plugin
export var banner = "_ir-0";
export var closeButton = "_ir-2";
export var greenCheckmark = "_ir-3";
export var hereLink = "_ir-4";
export var titleIcon = "_ir-1";